module.exports = __webpack_public_path__ + "static/media/RememberDroppedTiles.6d753763.jpg";